import vi from 'iview/dist/locale/vi-VN'
import viE from 'element-ui/lib/locale/lang/vi'

const viVN = Object.assign({
  'menu': {
    'home': 'nhà',
    'system': 'Quản lý bằnghệ thống',
    'system_management': {
      'Role': 'vai trò',
      'Department': 'bộ phận',
      'Account': 'tài khỏan',
      'WorkTime': 'ca làm việc',
      'WorkType': 'tên lọai công việc',
      'RoleEdit': 'điều chỉnh vai trò ',
      'DepartmentEdit': 'điều chỉnh bộ phận ',
      'AccountEdit': 'điều chỉnh tài khỏan',
      'WorkTimeEdit': 'điều chỉnh ca làm việc',
      'WorkTypeEdit': 'điều chỉnh nhân công',
      'systeminfo': 'thông tin',
      'SystemAuth': 'giấy phép'
    },
    'Device': 'Quản lý bằng thiết bị',
    'Device_management': {
      'RouterList': 'bộ định tâm',
      'RouterEdit': 'điều chỉnh bộ định tâm',
      'Collector': 'máy',
      'CollectorEdit': 'điều chỉnh máy móc',
      'CollectorGroup': 'nhóm máy móc',
      'CollectorGroupEdit': 'điều chỉnh nhóm máy móc'
    },
    'Card': 'Quản lý bằng thẻ',
    'CardEdit': 'điều chỉnh thẻ',
    'People': 'Người quản lý',
    'PeopleEdit': 'điều chỉnh con nguời',
    'Product': 'Quản lý nhân sự',
    'ProductEdit': 'điều chỉnh sản phẩm',
    'Order': 'Quản lý đơn hàng',
    'OrderEdit': 'điều chỉnh đặt hàng',
    'Plan': 'Quản ký sản xuất',
    'Plan_Management': {
      'Production_plan': 'kế họach sản xuất',
      'Production_management': 'quản lý sản xuất',
      'Production_order': 'đơn hàng sản xuất'
    },
    'Monitor': 'Giám sát tức thì',
    'Monitor_Monitoring': {
      'Collector': 'trạng thái máy',
      'Order': 'tình trạng đơn hàng'
    },
    'Data': 'Báo cáo',
    'Data_output': {
      'Order': ' đơn hàng',
      'device': 'thiết bị ',
      'Worker': 'công nhân',
      'MaintainList': 'danh sách bảo duỡng',
      'MaintainEdit': 'điều chỉnh bảo duỡng'
    },
    'Setting': 'cài đặt '
  },
  'system': {
    'Account': {
      'New_account': 'tài khỏan mới',
      'edit_account': 'đềiu chỉnh tài khỏan',
      'please_enter': 'Đăng nhập',
      'please_choose': 'chọn',
      'Return_to_account_list': 'trở về danh sách tài khỏan',
      'User_name': 'tên nguời dùng',
      'User_name_message': 'Vui lòng nhập tên nguời sử dụng',
      'Name': 'tên',
      'Name_message': 'nhập tên ',
      'Role': 'vai trò',
      'Role_message': 'chọn vài trò',
      'Worker_number': 'số seri công việc',
      'Department': 'bộ phận',
      'Department_message': 'chọn bộ phận',
      'Telephone': 'điện thoại',
      'Email': 'E-mail',
      'QQ': 'QQ',
      'Wechat': 'Wechat',
      'telephone': 'điện thọai',
      'email': 'E-mail:',
      'qq': 'QQ:',
      'wechat': 'Wechat:',
      'save': 'lưu',
      'index': 'Số seri',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'reseat': 'điều chỉnh lại',
      'error': 'lỗi',
      'error_message1': '<p> Tài khoản được lặp lại </ p>',
      'error_message2': '<p> Tài khoản được lặp lại </ p>',
      'delete_message': 'xóa tin nhắn'
    },
    'Department': {
      'New_Department': 'bộ phận mới',
      'edit_Department': 'tùy chỉnh bộ phận ',
      'index': 'Số seri',
      'Department': 'bộ phận',
      'Authorization': 'giấy phép',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'please_enter': 'Đăng nhập',
      'Return_to_depatement_list': 'trở lại bộ phận danh sách ',
      'name': 'tên',
      'Move_left': 'chuyển về bên trái',
      'Move_right': 'chuyền về bên phải',
      'save': 'lưu',
      'All_authorization': 'tất cả giấy phép',
      'Department_authorization': 'giấy phép bộ phận'
    },
    'Role': {
      'New_Role': 'vai trò mới',
      'edit_Role': 'tùy chỉnh vai trò ',
      'index': 'Số seri',
      'Role': 'vai trò',
      'Authorization': 'giấy phép',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'please_enter': 'Đăng nhập',
      'Return_to_role_list': 'trở về danh sách vai trò',
      'name': 'tên',
      'Move_left': 'chuyển về bên trái',
      'Move_right': 'chuyền về bên phải',
      'save': 'lưu',
      'All_authorization': 'tất cả giấy phép',
      'Role_authorization': 'vai trò giấy phép'
    },
    'workTime': {
      'New_workTime': 'ca làm việc mới',
      'edit_workTime': 'điều chỉnh ca làm việc',
      'index': 'Số seri',
      'name': 'tên',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'please_enter': 'Đăng nhập',
      'please_choose': 'vui lòng-chọn',
      'startTime': 'Thời gian bắt đầu',
      'endTime': 'Thời gian kết thúc',
      'Return_to_workTime_list': 'trở về danh sách ca làm việc',
      'save': 'lưu'
    },
    'workType': {
      'New_workType': 'thể lọai công việc mới',
      'edit_workType': 'điều chỉnh công việc mới',
      'index': 'Số seri',
      'name': 'tên',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'xóa tin nhắn',
      'please_enter': 'Đăng nhập',
      'Return_to_workType_list': 'trở về danh sách ca làm việc',
      'save': 'lưu',
      'yes': 'có ',
      'no': 'không',
      'outputValid': 'hiệu quả sản xuất',
      'monopoly': ' độc quyền',
      'maintain': 'bảo duỡng',
      'warn': 'báo tắt máy',
      'Sorting': 'sắp xếp',
      'display': 'màn hình',
      'malfunction': 'sự cố',
      'remark': 'Nhận xét'
    },
    'SystemAuth': {
      'Information': 'thông tin cơ bản',
      'systemVersion': 'phiên bản hệ thống',
      'systemDealTime': 'ngày hết hạn',
      'please_enter': 'Đăng nhập',
      'save': 'lưu',
      'save_success': 'lưu thành công',
      'systemAuthCode': 'mã '
    },
    'SystemInfo': {
      'Information': 'thông tin cơ bản',
      'Contect': 'liên hệ',
      'systemName': 'hệ thống tên',
      'please_enter': 'Đăng nhập',
      'name': 'tên',
      'contact': 'thông tin liên lạc',
      'address': 'địa chỉ',
      'phone': 'số điện thọai',
      'fax': 'số fax',
      'eMail': 'E-mail:',
      'save': 'lưu',
      'save_success': 'lưu thành công',
      'warnLimitTime': 'thời gian báo tắt máy'
    }
  },
  'device': {
    'collector': {
      'New_collector': 'máy mới',
      'edit_collector': 'điều chỉnh máy',
      'Return_to_collector_list': 'trở về danh sách máy',
      'name': 'tên',
      'deviceNo': 'đánh số',
      'routerID': 'bộ định tâm',
      'type': 'lọai máy',
      'computeType': 'phương pháp tính công suất',
      'roller': 'trục lăn',
      'weft_density': 'mật độ sợi ngang',
      'length': 'chu vi trục lăn',
      'count': 'số lượng',
      'width': 'chiều rộng vành đai',
      'deviceCompany': 'nhà sản xuất máy',
      'deviceModel': 'số hiệu máy',
      'buyTime': 'thời gian mua ',
      'deviceLifeTime': 'tuổi thọ máy',
      'please_enter': 'Đăng nhập',
      'please_enter_mm': 'vui lòng -nhập mm',
      'save': 'lưu',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'error': 'lỗi',
      'error_message1': 'báo lỗi- tin nhắn ',
      'error_message2': 'phải là số nguyên',
      'remark': 'Nhận xét',
      'Message': {
        'name': 'Vui lòng nhập tên',
        'deviceNo': 'vui lòng nhập số',
        'computeType': 'vui lòng nhập phuơng pháp tính năng suất',
        'routerID': 'vui lòng nhập bộ định tâm',
        'length': 'vui lòng nhập chu vi trục lăn',
        'count': 'vui lòng nhập dây đai',
        'width': 'vui lòng nhập chiều rộng dây đai'
      }
    },
    'group': {
      'New_group': 'nhóm máy mới',
      'edit_group': 'điều chỉnh nhóm máy',
      'Return_to_group_list': 'trở về danh sách nhóm máy',
      'please_enter': 'Đăng nhập',
      'save': 'lưu',
      'operating': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'index': 'Số seri',
      'name': 'tên',
      'devices': 'lựa chọn',
      'chosen': 'máy móc',
      'remark': 'Nhận xét',
      'width': 'chiều rộng',
      'router': 'bộ định tâm'
    },
    'router': {
      'New_router': 'bộ định tâm mới',
      'edit_router': 'điều chỉnh bộ định tâm ',
      'Return_to_router_list': 'trở về danh sách bộ định tâm ',
      'please_enter': 'Đăng nhập',
      'index': 'Số seri',
      'name': 'mã bộ định tâm',
      'AnotherName': 'tên bộ định tâm',
      'linkType': 'thể lọai kết nối',
      'channel': 'kênh tín hiệu',
      'remark': 'Nhận xét',
      'save': 'lưu',
      'action': 'Vận hành',
      'edit': 'cài đặt ',
      'delete': 'xóa ',
      'delete_message': 'Bạn có muốn xóa không?',
      'mod': 'thể lọai kết nối',
      'Lan': 'LAN cục bộ',
      'Internet': 'kết nối',
      'time': 'Sắp xếp lại',
      'save_success': 'Hệ thống và bộ sưu tập đã được sắp xếp lại'
    }
  },
  'Card': {
    'New_Card': 'thẻ mới',
    'edit_Card': 'điều chỉnh thẻ',
    'Return_to_Card_list': 'trở về danh sách thẻ',
    'please_enter': 'Đăng nhập',
    'index': 'Số seri',
    'userName': 'tên nguời dùng',
    'cardNo': 'số thẻ',
    'workTypeName': 'tên lọai công việc',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'delete': 'xóa ',
    'delete_message': 'Bạn có muốn xóa không?',
    'save': 'lưu',
    'error': 'lỗi',
    'error_message1': '<p> Lặp lại số thẻ </ p>',
    'error_message2': 'báo lỗi- tin nhắn '
  },
  'Product': {
    'New_Product': ' sản xuất mới',
    'edit_Product': 'điều chỉnh sản xuất',
    'Return_to_Product_list': 'trở về danh sách sản xuất',
    'please_enter': 'Đăng nhập',
    'index': 'Số seri',
    'productNo': 'đánh số',
    'name': 'tên',
    'latDensity': 'mật độ sợi ngang',
    'kaidu': 'sức căng',
    'width': 'chiều rộng',
    'specifications': 'Đặc điểm kỹ thuật',
    'valid': 'Hiệu quả',
    'yes': 'có ',
    'no': 'không',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'delete': 'xóa ',
    'delete_message': 'xóa tin nhắn',
    'save': 'lưu',
    'error': 'lỗi',
    'error_message': 'báo lỗi- tin nhắn ',
    'please_enter_kaidu': 'Vui lòng nhập nội dung nào đó (≧ 1)',
    'please_enter_mm': 'vui lòng nhập :mm',
    'please_enter_latDensity': 'vui lòng nhập nội dung (sợi ngang/cm)',
    'Message': {
      'productNo': 'Vui lòng nhập số sản phẩm',
      'name': 'Vui lòng nhập tên',
      'latDensity': 'Vui lòng nhập mật độ sợi ngang',
      'kaidu': 'Vui lòng nhập sức căng',
      'width': 'Vui lòng nhập chiều rộng '
    }
  },
  'Order': {
    'New_Order': 'đơn hàng mới',
    'edit_Order': 'điều chỉnh đơn hàng',
    'Return_to_Order_list': 'trở về danh sách đơn hàng',
    'please_enter': 'Đăng nhập',
    'please_enter_date': 'vui lòng nhập ngày',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'delete': 'xóa ',
    'save': 'lưu',
    'error': 'lỗi',
    'error_message1': '<p> Không có sản phẩm nào được thêm vào đơn đặt hàng </ p>',
    'error_message2': '<p> Thông tin đặt hàng không được điền </ p>',
    'error_message3': '<p> Số lượng không được điền </ p>',
    'error_message4': '<p> Đơn vị không được điền </ p>',
    'error_message5': '<p> Phân phối không được điền </ p>',
    'error_message6': '<p>請先選擇左側產品</p>',
    'delete_message': 'Bạn có muốn xóa không?',
    'change_message': 'Bạn có muốn mở trường hợp này không?',
    'orderNo': 'số đơn hàng',
    'customer': 'khách hàng',
    'ordersTime': 'ngày đặt hàng',
    'salesman': 'nhân viên kinh doanh',
    'index': 'Số seri',
    'productNo': 'số sản phẩm',
    'num': 'số lượng',
    'unit': 'đơn vị',
    'attritionRate': 'tỷ lệ phân tán',
    'deliveryTime': 'ngày giao hàng',
    'remark': 'Nhận xét',
    'add': 'Thêm vào đơn đặt hàng',
    'Product_list': 'Danh sách sản phẩm',
    'search': 'Số / tên',
    'No_scheduling': 'không lên lịch',
    'Not_production': 'không đưa vào sản xuất',
    'Producting': 'đưa vào sản xuất',
    'Case_closed': 'đã đóng',
    'name': 'tên',
    'Meter': 'mét',
    'Yard': 'đơn vị đo',
    'Gross': 'tỏng',
    'status': 'trạng thái',
    'Message': {
      'orderNo': 'Vui lòng nhập số sản phẩm',
      'ordersTime': 'Vui lòng nhập ngày đơn hàng',
      'customer': 'Vui lòng nhập khách hàng',
      'salesman': 'Vui lòng nhập bán hàng'
    }
  },
  'Login': {
    'username': 'Vui lòng nhập tên nguời sử dụng',
    'password': 'Vui lòng nhập mật khẩu',
    'systemCode': 'Vui lòng nhập mã hệ thống',
    'language': '請選擇語言',
    'login': 'Đăng nhập',
    'system': 'hệ thống đăng nhập',
    'changePw': 'thay đổi mật khẩu',
    'logout': 'Đăng xuất',
    'Information': 'Thông tin cá nhân'
  },
  'ChangePw': {
    'oldPassword': 'nhập mật khẩu cũ',
    'newPassword': 'nhập mật khẩu mới',
    'comfirmPassword': 'xác nhận mật khẩu mới',
    'save': 'lưu',
    'error': 'Hai mục nhập mật khẩu không nhất quán',
    'success': 'Đã sửa đổi thành công',
    'ChangePw': 'thay đổi mật khẩu'
  },
  'monitor': {
    'Collector': {
      'index': 'Số seri',
      'name': 'tên',
      'group': 'nhóm',
      'deviceNo': 'đánh số',
      'rpm': 'Tốc độ máy RPM',
      'status': 'trạng thái máy',
      'status1': 'Trạng thái thiết bị',
      'error': 'Thông báo lỗi',
      'worker': 'công nhân',
      'workType': 'trạng thái thẻ',
      'lastTime': 'thời gian',
      'timeout': 'ngọai tuyến',
      'trial': 'Chạy thử',
      'standby': 'Đứng gần',
      'run': 'Đang chạy',
      'orderNo': 'số đơn hàng',
      'producNo': 'seri đơn hàng',
      'stop': 'chế độ chờ',
      'warp': 'làm cong',
      'weft': 'Sợi ngang',
      'thread': 'chủ đề',
      'roll': 'trục lăn'
    },
    'Order': {
      'index': 'Số seri',
      'orderNo': 'số đơn hàng',
      'producNo': 'seri đơn hàng',
      'salesman': 'bán hàng',
      'ordersTime': 'thời gian đặt hàng',
      'output': 'Năng suất',
      'num': 'số lượng đơn hàng',
      'unit': 'đơn vị',
      'countdata': 'số máy',
      'name': 'tên',
      'rpm': 'Tốc độ máy RPM',
      'worker': 'công nhân',
      'workType': 'trạng thái thẻ',
      'DailyOutput': 'Sản xuất hàng ngày',
      'deliveryTime': 'ngày giao hàng',
      'today': 'Sản xuất hàng ngày',
      'completed': '已生產完成',
      'fastestdelivery': '預估交期',
      'please_enter_date1': 'Ngày bắt đầu giao hàng',
      'please_enter_date2': 'Ngày kết thúc giao hàng',
      'Meter': 'mét',
      'Yard': 'đơn vị đo',
      'Gross': 'tỏng'
    }
  },
  'data': {
    'Device': {
      'name': 'máy',
      'date': 'ngày',
      'group': 'nhóm',
      'output': 'Năng suất',
      'unit': 'đơn vị',
      'runTotalTime': 'tổng thời gian chạy',
      'stopTime': 'Thời gian ngừng hoạt động',
      'stopTotalTime': ' tổng thời gian ngừng họat động',
      'error1Time': 'báo lỗi 1: làm cong ',
      'error1TotalTime': 'tổng báo lỗi 1: làm cong ',
      'error2Time': 'báo lỗi 2: sợi ngang ',
      'error2TotalTime': 'tổng báo lỗi 2:sợi ngang ',
      'error3Time': 'báo lỗi 3: sợi duới cùng ',
      'error3TotalTime': 'tổng báo lỗi 3: sợi duới cùng',
      'error4Time': 'báo lỗi 4: thời gian bị lỗi',
      'error4TotalTime': 'tổng báo lỗi 4: thời gian bị lỗi',
      'S': 'giây',
      'M': 'phút',
      'H': 'giờ ',
      'D': 'ngày',
      'Meter': 'mét',
      'output_report': 'báo cáo sản lượng',
      'run_report': 'báo cáo tình trạng',
      'please_enter': 'chọn',
      'please_enter_date': 'chọn ngày',
      'start_date': 'ngày bắt đầu',
      'end_date': 'ngày kết thúc',
      'ok': 'lưu',
      'out': 'đầu ra',
      'status': 'trạng thái hoạt động'
    },
    'Order': {
      'orderNo': 'seri đặt hàng',
      'productNo': 'seri đơn hàng',
      'collectorName': 'máy',
      'salesman': 'nhân viên kinh doanh',
      'customer': 'khách hàng',
      'ordersTime': 'thời gian đặt hàng',
      'productTime': 'thời gian sản xuất',
      'output': 'sản xuất thực tế',
      'target': 'mục tiêu dơn hàng',
      'num': 'số lượng đơn hàng',
      'unit': 'đơn vị',
      'deliveryTime': 'thời gian giao hàng',
      'Meter': 'mét',
      'Yard': 'đơn vị đo',
      'Gross': 'tỏng',
      'Order_report': 'báo cáo đơn hàng',
      'ok': 'lưu',
      'out': 'đầu ra',
      'please_enter': 'chọn',
      'please_enter_date': 'chọn ngày',
      'start_date': 'ngày bắt đầu',
      'end_date': 'ngày kết thúc',
      'time_range': 'Time range',
      'No_scheduling': 'không lên lịch',
      'Not_production': 'không đưa vào sản xuất',
      'Producting': 'đưa vào sản xuất',
      'Case_closed': 'đã đóng',
      'status': 'trạng thái',
      'history': 'thứ tự đơn hàng'
    }
  },
  'setting': {
    'Basic_Information': 'thông tin cơ bản',
    'company_information': 'thông tin công ty',
    'Contact_information': 'liên hệ',
    'save': 'lưu',
    'please_enter': 'Đăng nhập',
    'username': 'tên người dùng',
    'name': 'tên',
    'company': 'công ty',
    'workNo': 'seri làm việc',
    'department': 'bộ phận',
    'workPosition': 'chức vụ',
    'role': 'vai trò',
    'phone': 'điện thoại',
    'eMail': 'E_mail',
    'qq': 'QQ',
    'wechat': 'wechat',
    'System_setting': 'cấu hình hệ thống',
    'language': 'ngôn ngữ',
    'zhcn': '簡體中文',
    'zhtw': '繁體中文',
    'enUS': 'English',
    'jaJP': '日本語',
    'viVN': 'Việt Nam - Tiếng việt',
    'thTH': 'ไทย - ไทย (แปรตรงตัว)'
  },
  'plan': {
    'Collector': {
      'search': 'tên máy',
      'name': 'máy',
      'one': 'lô thư 1',
      'two': 'lô thư 2',
      'three': 'lô thứ 3',
      'four': 'lô thứ 4',
      'fiv': 'lô thứ 5',
      'six': 'lô thứ 6',
      'orderNo': 'seri đơn hàng',
      'productNo': 'seri sản xuất',
      'row': 'số lượng',
      'delete_message': 'ngừng sản xuất',
      'yes': 'bắt đầu',
      'no': 'dừng lại'
    },
    'Order': {
      'orderNo': 'số seri đơn hàng',
      'customer': 'khách hàng',
      'ordersTime': 'ngày đặt hàng',
      'salesman': 'nhân viên bán hàng',
      'index': 'Số seri',
      'productNo': 'số sản phẩm',
      'num': 'số lượng',
      'unit': 'đơn vị',
      'attritionRate': 'tỷ lệ phân tán',
      'output': 'số hoàn thành',
      'deliveryTime': 'ngày giao hàng',
      'action': 'Vận hành',
      'Meter': 'mét',
      'Yard': 'đơn vị đo',
      'Gross': 'tỏng',
      'delete_message': 'xóa đơn hàng',
      'case1': 'đã đóng PO',
      'case2': 'đã đóng'
    },
    'Production': {
      'productNo': 'số sản phẩm',
      'productName': '產品名稱',
      'deliveryTime': 'thời gian giao hàng',
      'num': 'số lượng',
      'name': 'Tên máy',
      'count': 'số lượng',
      'width': 'chiều rộng',
      'collectorName': 'Tên máy',
      'orderNo': 'số seri đơn hàng',
      'planIndex': 'lô hàng',
      'row': 'số lượng',
      'action': 'Vận hành',
      'delete': 'xóa ',
      'error': 'lỗi',
      'error_message': 'số mục không được chọn',
      'planClick': 'lich kế hoạch',
      'please_enter': 'Đăng nhập',
      'deviceNo': 'đánh số',
      'save': 'lưu',
      'save1': 'gửi đơn hàng 1',
      'save2': 'chèn đơn hàng 1',
      'save3': 'sản xuất',
      'No_scheduling': 'không lên lịch',
      'Not_production': 'không đưa vào sản xuất',
      'Producting': 'đưa vào sản xuất',
      'Case_closed': 'đã đóng',
      'status': 'trạng thái',
      'no': 'dừng lại',
      'delete_message': 'xóa tin nhắn',
      'searchCollector': 'Tên máy',
      'chooose_order': '1.選擇訂單',
      'choose_device': '2.選擇機台',
      'choose_plan': '3.排產計畫',
      'list': 'lich kế hoạch',
      'message': '此產品已經結案'
    }
  },
  'People': {
    'index': 'Số seri',
    'name': 'tên',
    'workNo': 'số seri công việc',
    'sex': 'giới tính',
    'boy': 'nam',
    'girl': 'nữ',
    'phone': 'điện thoại',
    'entryTime': 'thời gain nhập cảnh',
    'wechat': 'WECHAT',
    'qq': 'QQ',
    'working': 'đang làm việc 2',
    'working1': 'đang làm việc 2',
    'working2': 'khởi động',
    'yes': 'có ',
    'no': 'không',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'edit_People': 'người cài đặt',
    'Return_to_People_list': 'quay trở lại danh sách người',
    'please_enter': 'Đăng nhập',
    'please_enter_date': 'chọn ngày',
    'save': 'lưu'
  },
  'Maintain': {
    'index': 'Số seri',
    'DeviceName': 'Tên máy',
    'username': 'Vận hành',
    'startTime': 'Thời gian bắt đầu',
    'endTime': 'Thời gian kết thúc',
    'remark': 'Nhận xét',
    'action': 'Vận hành',
    'edit': 'cài đặt ',
    'edit_Maintain': 'cài đặt hồ sơ bảo trì',
    'Return_to_Maintain_list': 'Quay lại danh sách sữa chữa',
    'save': 'lưu',
    'please_enter': 'Đăng nhập',
    'please_enter_date1': 'Thời gian bắt đầu',
    'please_enter_date2': 'Thời gian kết thúc'
  },
  'Permission': {
    'super_admin': 'Hệ thống siêu cấp',
    'system': 'Quản lý bằnghệ thống',
    'device': 'Quản lý bằng thiết bị',
    'card': 'Quản lý bằng thẻ',
    'people': 'Người quản lý',
    'product': 'Quản lý nhân sự',
    'order': 'Quản lý đơn hàng',
    'production_plan': 'Quản ký sản xuất',
    'monitor': 'Giám sát tức thì',
    'report_export': 'Báo cáo',
    'R': 'R',
    'W': 'W',
    'RW': ' RW'
  }
}, vi, viE)

export default viVN



// WEBPACK FOOTER //
// ./src/lang/vi-VN.js